// extracted by mini-css-extract-plugin
export default {"modalOverlay":"pC-z","modalContent":"qC-z","header":"rC-z","close":"sC-z"};